import { retrieveNoteList } from '@/api/school';

const initialState = () => ({
  loading: false,
  content: [],
  pagination: {
    page: 0,
    perPage: 10,
  },
  hasMore: true,
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setContent(state, { data }) {
      state.content = state.content.concat(data);
      if (data.length < state.pagination.perPage) {
        state.hasMore = false;
        state.pagination.page = 0;
      } else {
        state.pagination.page += 1;
      }
    },
    removeOne(state, id) {
      state.content = state.content.filter(item => item.id !== id);
    },
    resetState(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    async getContent({ commit, getters, dispatch }) {
      try {
        commit('setLoading', true);
        commit('setContent', await retrieveNoteList(getters.pagination));
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading && !state.content.length,
    loadMoreLoading: state => state.loading && !!state.content.length,
    content: state => state.content || [],
    pagination: state => state.pagination,
    hasMore: state => state.hasMore && !!state.content.length,
  },
};
